/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Studio_1_TitleInputs */

const en_mk_studio_1_title = /** @type {(inputs: Mk_Studio_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimates from real data`)
};

const id_mk_studio_1_title = /** @type {(inputs: Mk_Studio_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimasi dari data nyata`)
};

/**
* | output |
* | --- |
* | "Estimates from real data" |
*
* @param {Mk_Studio_1_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_studio_1_title = /** @type {((inputs?: Mk_Studio_1_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Studio_1_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_studio_1_title(inputs)
	return en_mk_studio_1_title(inputs)
});